import {
  Column,
  Entity,
  JoinColumn,
  ManyToOne,
  PrimaryGeneratedColumn,
} from "typeorm";
import { Organization, User } from ".";

@Entity()
export class OrgChangeRequest {
  @PrimaryGeneratedColumn() id: number;

  @Column("int") organizationId: number;

  @ManyToOne(
    () => Organization,
    (organization) => organization.orgChangeRequests
  )
  organization: Organization;

  @Column("varchar") fieldname: string;
  @Column("varchar") value: string;
  @Column("varchar", { default: "PENDING" })
  status: string;
  @Column("datetime") createdAt: Date;
  @Column("datetime") updatedAt: Date;

  @ManyToOne(() => User)
  @JoinColumn()
  updatedBy: User;

  @ManyToOne(() => User)
  @JoinColumn()
  createdBy: User;
}
